import * as $ from 'jquery';

$(window).on('resize', (function () {
	var browserHeight = $(window).height();
	var alertBarHeight = $(".alertBar").height();
	var menuHeight = $(".pageHeader").height();

	$(".map-set-up").css({ "height": (browserHeight - alertBarHeight - menuHeight) });
}));

import { default as mapControllerInitializer } from './component/MapController';
mapControllerInitializer();